import { render } from "./DocumentSkeleton.vue?vue&type=template&id=2c098cf7&scoped=true"
const script = {}

import "./DocumentSkeleton.vue?vue&type=style&index=0&id=2c098cf7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c098cf7"]])

export default __exports__